const CardProfile = ({children}) => {
    return (
        <>
            <div className='bg-white rounded-md shadow-sm p-6 w-full'>
                {children}
            </div>
        </>
    )
}

export default CardProfile;